/**
 * Horizon Pro — Cart Drawer Enhancements
 * Handles upsell "Add" button clicks inside the cart drawer.
 * Uses event delegation on document so handlers survive DOM morphs.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hp-upsell__add-btn');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    btn.disabled = true;

    /* Swap icon to spinner */
    var origHTML = btn.innerHTML;
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="hp-upsell__spinner" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="10" opacity="0.25"/>' +
      '<path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"/>' +
      '</svg>';

    var variantId = btn.dataset.variantId;
    var cartItems = document.querySelector('cart-items-component[data-drawer]');
    var sectionId = cartItems ? cartItems.dataset.sectionId : null;

    var payload = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
    };
    if (sectionId) payload.sections = sectionId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed: ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (data.sections && sectionId && data.sections[sectionId]) {
          /* Dispatch cart:update so our morph interceptor handles the drawer refresh */
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { sections: data.sections } },
            })
          );
        } else if (sectionId) {
          /* Fallback: fetch section HTML directly */
          fetch('/?sections=' + encodeURIComponent(sectionId))
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { data: { sections: sections } },
                })
              );
            });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = origHTML;
      });
  });
})();
